<template>
    <li>
        <button
            @click="toggleDropdownVisible"
            :disabled="!tray?.product_count"
            :aria-expanded="isDropdownVisible"
            class="disabled:opacity-50 disabled:pointer-events-none bg-v2-white border border-v2-white flex font-medium gap-3 items-center leading-none max-w-full p-3 relative rounded text-v2-gray-20 text-left text-xs w-full hover:border-v2-gray-70 dark:bg-v2-gray-65 dark:border-v2-gray-10 dark:text-v2-gray-130 hover:dark:border-v2-gray-90 hover:dark:text-v2-white"
        >
            <BaseSvg
                name="Add"
                aria-hidden="true"
                class="fill-v2-gray-70 shrink-0 size-4 dark:fill-v2-gray-90"
            />
            Add {{ tray.product_count }} {{ useHelpers().pluralize(tray.product_count, 'product', 'products') }} to...
            <BaseSvg
                :name="isDropdownVisible ? 'ExpandLess' : 'ExpandMore'"
                aria-hidden="true"
                class="fill-v2-gray-70 ml-auto shrink-0 size-5 dark:fill-v2-gray-90"
            />
        </button>
        <div
            v-if="isDropdownVisible"
            class="bg-v2-white -mt-1 pb-3 pt-1 px-3 rounded-b text-xs dark:bg-v2-gray-65 dark:border dark:border-v2-gray-10 dark:border-t-0 dark:relative"
        >
            <button
                @click="addTrayToCart(tray.name)"
                :disabled="isLoading"
                class="btn-app-sm-white-on-black disabled:opacity-50 disabled:pointer-events-none flex gap-1 items-center justify-center font-medium px-3 py-1.5 w-full">
                <LoadingCircle v-if="isLoading" class="mr-0.5" />
                <BaseSvg
                    v-else
                    name="ShoppingCart"
                    :aria-hidden="!isDropdownVisible"
                    class="size-[18px]"
                />
                {{ $t('Add to cart') }}
            </button>
            <h3 class="font-semibold mt-4 text-[12px] text-v2-gray-80 uppercase">Projects</h3>
            <LoadingCircle v-if="isLoadingProjects" />
            <ul v-else-if="projects?.length" class="max-h-40 mt-2 space-y-3 dark:text-v2-gray-130" :class="projects.length > 4 ? 'overflow-shadows-vertical overscroll-contain' : ''">
                <li v-for="project in projects" :key="project.id">
                    <label class="flex font-medium gap-3 items-center leading-none">
                        <input
                            type="checkbox"
                            :value="project.id"
                            class="peer sr-only"
                            @change="addToProject(project.uuid, tray)"
                        />
                        <BaseSvg
                            name="Check"
                            aria-hidden="true"
                            class="border border-v2-gray-90 fill-none p-px rounded-full shrink-0 size-4 peer-checked:border-v2-green peer-checked:fill-v2-green dark:bg-v2-gray-40 dark:border-v2-gray-70"
                        />
                        <span class="truncate">{{ project.label }}</span>
                    </label>
                </li>
            </ul>
            <div v-else class="type-tertiary">No Projects Yet</div>
        </div>
    </li>
</template>

<script setup>
import {inject, onMounted, ref} from "vue";
import {useHelpers, usePinsDrawer, useProjects} from "@/Composables";
import {LoadingCircle} from "@/Components";

const props = defineProps(['tray']);
const { addTrayToCart, addToProject, isLoading } = usePinsDrawer();
const { isLoadingProjects, loadProjects, projects } = useProjects();

const isDropdownVisible = ref(false);

function toggleDropdownVisible() {
    isDropdownVisible.value = !isDropdownVisible.value;
}

onMounted(() => {
    loadProjects();
});
</script>
